import Vue from 'vue'
import App from './App.vue'
import router from './router'
import ElementUI from 'element-ui';
import '@/assets/baseStyle.css';
import 'element-ui/lib/theme-chalk/index.css';
import {
  STATICURL,
} from "@/config/index.js";
Vue.use(ElementUI);
import axios from 'axios';
Vue.prototype.$axios = axios;
import store from './store'

Vue.config.productionTip = false
  ;
if (localStorage.getItem('zh_en') != 'en' && localStorage.getItem('zh_en') != 'zh') {
  localStorage.setItem('zh_en', 'zh')
}
if (localStorage.getItem('zh_en')) {
  Vue.prototype.zh_en = localStorage.getItem('zh_en');

}
if (localStorage.getItem('bgimg')) {
  Vue.prototype.bgimg = localStorage.getItem('bgimg');
}
Vue.prototype.STATICURL = STATICURL; // 存放在腾讯云COS存储上的前端静态资源文件地址
new Vue({
  router,
  el: '#app',
  store,
  render: h => h(App)
}).$mount('#app')

